import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle, Clapperboard } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0D0F12] flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-[#14181F] border border-[#28303F] rounded-2xl p-8 text-center" data-testid="payment-cancel-card">
        <div className="flex items-center justify-center gap-2 mb-6 text-gray-500">
          <Clapperboard size={18} className="text-amber-400" />
          <span className="font-[Outfit] font-bold text-white">Get2Set</span>
        </div>
        <XCircle size={44} className="mx-auto text-gray-500" />
        <h1 className="mt-4 text-xl font-bold">Checkout canceled</h1>
        <p className="text-sm text-gray-400 mt-2">
          No worries — nothing has been charged. Pick a plan when you're ready.
        </p>
        <button
          onClick={() => navigate("/billing")}
          data-testid="payment-cancel-retry"
          className="mt-6 w-full bg-amber-500 hover:bg-amber-400 text-black font-semibold py-2.5 rounded-lg"
        >
          Back to pricing
        </button>
      </div>
    </div>
  );
}
